import { Trans } from "react-i18next";

import util from "utils/utils";

export default function IdeaAddedAsCollaboratorContent({ events, ownerIdea }) {
  return (
    <Trans
      i18nKey="notifications.ideaAddedAsCollaborator"
      values={{
        name: util.getEventNames(events),
        action: "added",
        idea: ownerIdea?.name || "Deleted",
      }}
      components={{ b: <b /> }}
    />
  );
}
